import { Box } from '@bechtel/gds';
// import { UiTextEnum } from '@bechtel/sr-types';
// import { map } from 'lodash';
// import { MultiLingualText, SearchField, useLanguage } from '~/components';
// import { CommodityConnectionItem } from './item';
// import { commodityConnectionList } from './mock';
import { UnderConstruction } from '~/components';
export const CommodityConnection = () => {
  // const { getMultiLingualTextByKey } = useLanguage();
  return (
    <Box pt={{ sm: '500' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <Box flexGrow={{ sm: ' 1' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
        <UnderConstruction />
      </Box>
      {/* <Box mb={{ sm: '450' }} flexDirection={{ sm: 'column' }} px={{ sm: '500' }}>
        <Text size="500" weight="700" color="primary.700">
          Equip #02K-12A41-2
        </Text>
        <Box mt={{ sm: '200' }}>
          <MultiLingualText size="300" weight="400" color="grey.700">
            Associated Commodities
          </MultiLingualText>
        </Box>
      </Box>
      <Box mb={{ sm: '550' }} px={{ sm: '500' }}>
        <SearchField placeholder={getMultiLingualTextByKey(UiTextEnum.SEARCH)} />
      </Box>
      <Box pl={{ sm: '700' }} pr={{ sm: '500' }} flexDirection={{ sm: 'column' }} css={{ overflow: 'auto' }}>
        {map(commodityConnectionList, (item) => (
          <CommodityConnectionItem item={item} key={item.id} />
        ))}
      </Box> */}
    </Box>
  );
};
